
// script.js
document.addEventListener("DOMContentLoaded", () => {
  const toast = window.showCareerToast || function () {};

  const form = document.getElementById("applicationForm");
  const steps = document.querySelectorAll(".form-step");
  const wizardSteps = document.querySelectorAll(".wizard-step");
  const nextBtn = document.querySelector(".nav-next");
  const backBtn = document.querySelector(".nav-back");
  const categoryCards = document.querySelectorAll(".category-card");
  const desiredRoleSelect = document.getElementById("desiredRole");
  const medicalQualifications = document.getElementById("medicalQualifications");
  const nonMedicalQualifications = document.getElementById("nonMedicalQualifications");
  const summaryEl = document.getElementById("summary");
  const yearSpan = document.getElementById("year");

  let currentStep = 1;
  const totalSteps = steps.length;

  if (yearSpan) {
    yearSpan.textContent = new Date().getFullYear();
  }

  /* Smooth scroll for hero button */
  document.querySelectorAll("[data-scroll-target]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetSel = btn.getAttribute("data-scroll-target");
      const target = document.querySelector(targetSel);
      if (target) {
        const top = target.offsetTop - 80;
        window.scrollTo({ top, behavior: "smooth" });
      }
    });
  });

  /* ===== STEP CONTROL ===== */

  function showStep(step) {
    currentStep = step;
    steps.forEach((section) => {
      section.classList.toggle("active", Number(section.dataset.step) === step);
    });
    wizardSteps.forEach((node) => {
      const stepNo = Number(node.dataset.step);
      node.classList.toggle("active", stepNo === step);
      node.classList.toggle("completed", stepNo < step);
    });

    if (backBtn) {
      backBtn.disabled = step === 1;
      backBtn.style.opacity = step === 1 ? "0.6" : "1";
    }

    const appSection = document.getElementById("application");
    if (appSection) {
      const top = appSection.offsetTop - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  function clearErrors(stepEl) {
    stepEl.querySelectorAll(".field-error").forEach((el) => el.remove());
    stepEl.querySelectorAll(".input-error").forEach((el) =>
      el.classList.remove("input-error")
    );
  }

  function showFieldError(field, msg) {
    const container = field.closest(".field") || field.parentElement;
    if (!container) return;
    const existing = container.querySelector(".field-error");
    if (existing) existing.remove();
    const error = document.createElement("div");
    error.className = "field-error";
    error.textContent = msg || "This field is required.";
    container.appendChild(error);
    field.classList.add("input-error");
  }

  function validateStep(step) {
    const stepEl = document.querySelector(`.form-step[data-step="${step}"]`);
    if (!stepEl) return true;

    clearErrors(stepEl);
    let valid = true;

    const requiredFields = stepEl.querySelectorAll("[data-required='true']");
    requiredFields.forEach((field) => {
      // Skip if inside a hidden section (e.g., medical vs non-medical)
      if (field.closest(".hidden")) return;

      let isValid = true;
      if (field.type === "radio") {
        const name = field.name;
        const groupChecked = stepEl.querySelector(
          `input[name="${name}"]:checked`
        );
        if (!groupChecked) {
          isValid = false;
        }
      } else if (field.type === "checkbox") {
        if (!field.checked) {
          isValid = false;
        }
      } else {
        const value = field.value != null ? field.value.trim() : "";
        if (!value) {
          isValid = false;
        }
      }

      if (!isValid) {
        valid = false;
        showFieldError(field, "This field is required.");
      }
    });

    if (!valid) {
      // Use a generic required-fields toast
      toast("error", "requiredFields");
    } else if (currentStep < totalSteps) {
      toast("info", "saveStep", { duration: 2000 });
    }

    return valid;
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      if (!validateStep(currentStep)) return;
      if (currentStep < totalSteps) {
        if (currentStep === totalSteps - 1) {
          // going to final step – generate summary
          generateSummary();
        }
        showStep(currentStep + 1);
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener("click", () => {
      if (currentStep > 1) {
        showStep(currentStep - 1);
      }
    });
  }

  /* ===== CATEGORY & ROLE FLOW ===== */

  const roleOptions = {
    nursing: [
      "Homecare Staff Nurse",
      "Registered Nurse – Adult",
      "Registered Nurse – Paediatric",
      "Assistant Nurse / Caregiver",
      "Midwife",
      "Other nursing role"
    ],
    health: [
      "Physiotherapist",
      "Lab Technician",
      "Phlebotomist",
      "Pharmacist",
      "Other health professional"
    ],
    nonMedical: [
      "Care Assistant",
      "Driver",
      "Call‑centre Agent",
      "Customer Support / Operator",
      "Operations / Logistics",
      "Admin / Reception",
      "Other non‑medical role"
    ]
  };

  function populateRoles(categoryKey) {
    if (!desiredRoleSelect) return;
    desiredRoleSelect.innerHTML = '<option value="">Select a role</option>';
    const options = roleOptions[categoryKey] || [];
    options.forEach((role) => {
      const opt = document.createElement("option");
      opt.value = role;
      opt.textContent = role;
      desiredRoleSelect.appendChild(opt);
    });
  }

  function updateQualificationFlow(categoryKey) {
    if (!medicalQualifications || !nonMedicalQualifications) return;
    const isNonMedical = categoryKey === "nonMedical";
    medicalQualifications.classList.toggle("hidden", isNonMedical);
    nonMedicalQualifications.classList.toggle("hidden", !isNonMedical);
  }

  categoryCards.forEach((card, index) => {
    card.addEventListener("click", () => {
      categoryCards.forEach((c) => c.classList.remove("active"));
      card.classList.add("active");
      const key = card.dataset.category;
      populateRoles(key);
      updateQualificationFlow(key);
      toast("info", "categoryChanged", { duration: 2200 });
    });
    // default selection
    if (index === 0) {
      card.classList.add("active");
      populateRoles(card.dataset.category);
      updateQualificationFlow(card.dataset.category);
    }
  });

  /* ===== SUMMARY ===== */

  function getVal(id) {
    const el = document.getElementById(id);
    return el ? (el.value || "").trim() : "";
  }

  function getRadioText(name) {
    const checked = document.querySelector(`input[name="${name}"]:checked`);
    if (!checked) return "";
    if (checked.nextElementSibling && checked.nextElementSibling.tagName === "SPAN") {
      return checked.nextElementSibling.textContent.trim();
    }
    return checked.value || "";
  }

  function generateSummary() {
    if (!summaryEl) return;

    const categoryCard = document.querySelector(".category-card.active");
    const categoryLabel = categoryCard
      ? categoryCard.querySelector(".category-title").textContent.trim()
      : "";

    const data = [
      ["Full name", (getVal("firstName") + " " + getVal("lastName")).trim()],
      ["Mobile number", getVal("phone")],
      ["Current location", [getVal("city"), getVal("country")].filter(Boolean).join(", ")],
      ["Location status", getRadioText("locationStatus")],
      ["Work eligibility", getVal("workEligibility")],
      ["Earliest joining date", getVal("joinDate")],
      ["Category", categoryLabel],
      ["Role applied for", getVal("desiredRole")],
      ["Highest education", getVal("highestEducation")],
      ["Total years of experience", getVal("yearsExperience")],
      ["Homecare experience (years)", getVal("homecareExperience")],
      ["Most recent employer", getVal("employer1Name")],
      ["Most recent job title", getVal("employer1Title")]
    ];

    // For clinical applicants, add licence details
    if (!medicalQualifications.classList.contains("hidden")) {
      data.push(
        ["Healthcare qualification", getVal("healthQualification")],
        ["Graduation year", getVal("graduationYear")],
        ["Graduation country", getVal("graduationCountry")],
        ["Licence authority", getVal("licenseAuthority")],
        ["Licence country", getVal("licenseCountry")],
        ["QCHP status", getVal("qchpStatus")],
        ["Certificates attested", getVal("documentsAttested")],
        ["Licence valid", getVal("licenseValid")]
      );
    }

    const items = data
      .filter(([, value]) => value && String(value).trim() !== "")
      .map(
        ([label, value]) =>
          `<dt>${label}</dt><dd>${value}</dd>`
      )
      .join("");

    summaryEl.innerHTML = `<h4>Application summary</h4><dl>${items}</dl>`;
  }

  /* ===== FORM SUBMIT ===== */

  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      // Validate current step
      if (!validateStep(currentStep)) return;

      // Validate declarations specifically (step 4)
      const declStep = document.querySelector('.form-step[data-step="4"]');
      if (declStep) {
        const declFields = declStep.querySelectorAll("[data-required='true']");
        let declValid = true;
        declFields.forEach((field) => {
          if (!field.checked) {
            declValid = false;
            showFieldError(field, "Please tick this box to continue.");
          }
        });
        if (!declValid) {
          toast("error", "declarations");
          return;
        }
      }

      // In a real system, you would submit via AJAX or standard POST here.
      toast("success", "applicationSubmitted", { duration: 4200 });

      // Optional: reset form after short delay to let user read toast
      setTimeout(() => {
        form.reset();
        // Rebuild roles/flow with default category
        const firstCategory = categoryCards[0];
        if (firstCategory) {
          categoryCards.forEach((c) => c.classList.remove("active"));
          firstCategory.classList.add("active");
          populateRoles(firstCategory.dataset.category);
          updateQualificationFlow(firstCategory.dataset.category);
        }
        showStep(1);
      }, 800);
    });
  }

  // Init first step
  showStep(1);
});
